import { MobileContent } from "../layout/MobileContent";
import MobileHeader from "../layout/MobileHeader";
import { useApprovalQueue } from "./useApprovalQueue";
import { ApprovalQueueCard } from "./ApprovalQueueCard";

export const ApprovalQueueListMobile = () => {
  const { data: items, isPending, isError } = useApprovalQueue();

  return (
    <>
      <MobileHeader>
        <h1 className="text-xl font-semibold">Approval Queue</h1>
      </MobileHeader>
      <MobileContent>
        <div className="flex flex-col gap-3">
          {isPending && (
            <p className="text-muted-foreground text-sm">Loading…</p>
          )}
          {isError && (
            <p className="text-muted-foreground text-sm italic">
              Couldn't load the approval queue.
            </p>
          )}
          {!isPending && !isError && items?.length === 0 && (
            <p className="text-muted-foreground text-sm italic">
              Nothing waiting on review.
            </p>
          )}
          {items?.map((item) => (
            <ApprovalQueueCard key={item.id} item={item} />
          ))}
        </div>
      </MobileContent>
    </>
  );
};
